import React from 'react';
import BaseComponent from '../components/BaseComponent';
import { GetQuiteDetails, Statistics } from '../common/ApiHelper';
import { H5AudioManager } from '../common/H5AudioManager';
import { sec_to_time } from '../common/Tools';
import AsyncImg from '../components/AsyncImgComponent';

class Listen extends BaseComponent {
    state: {
        Data: QuiteDetails['Data']['bookDetails'],
        playClass: string,
        CurrentTime: string,
        Duration: string,
        playIndex: number,
        Progress: number
    } = {
        Data: {
            ClassifyTitle: '',
            collect: 0,
            sectionList: [],
            bookID: 0,
            imgUrl: '',
            name: '',
            writer: '',
            lookCount: 0,
            downCount: 0,
            intro: ''
        },
        playClass: 'jp-audio',
        CurrentTime: '00:00:00',
        Duration: '00:00:00',
        playIndex: 0,
        Progress: 0
    }
    public audioManager: H5AudioManager;
    public first = true;
    public bookId = 0;
    constructor(props: any) {
        super(props);
        this.audioManager = new H5AudioManager();
        this.audioManager.onTimeUpdate(()=>{
            if (this.audioManager === undefined || isNaN(this.audioManager.duration)) return;
            const date = sec_to_time(this.audioManager.currentTime);
            this.setState({ CurrentTime: date, Progress: (this.audioManager.currentTime / this.audioManager.duration * 100) })
        });
        this.audioManager.onCanplay(() => {
            const am = this.audioManager;
            if (isNaN(am.duration)) return;
            const date = sec_to_time(am.currentTime);
            const duration = sec_to_time(am.duration);
            this.setState({ CurrentTime: date, Duration: duration })
        })
        this.audioManager.onEnded(()=>{
            this.onNext();
        });
    }
    componentWillUnmount() {
        this.RemoveToast();
        this.audioManager.pause();
        delete this.audioManager;
    }
    componentDidMount() {
        const bookid = this.GetQueryString(this.props.location.search,'bookid')!;
        this.bookId = parseInt(bookid);
        this.ShowToast();
        GetQuiteDetails(bookid, (res)=>{
            if (res.ResultCode !== 0) {
                this.RemoveToast();
                this.ShowToast(res.Msg, 1, 3000);
                return;
            }
            const src = res.Data.bookDetails.sectionList[this.state.playIndex].fileUrl;
            this.audioManager!.src = src;
            this.setState({Data: res.Data.bookDetails}, ()=>{
                this.RemoveToast();
                this.InitReadHistory();
            });
        });
        jQuery(".c-slide").slide();
    }
    public onPlayClick = () => {
        if (this.state.playClass === 'jp-audio') {
            this.play();
            // this.audioManager.play();
            // this.setState({ playClass: 'jp-audio jp-state-playing' });
        }
        else {
            this.audioManager.pause();
            this.setState({ playClass: 'jp-audio' });
        }
    }
    public onItemClick = (src: string, index: number) => {
        this.play(src);
        this.setState({playIndex: index})
    }
    public play = (src?: string) => {
        if (src !== undefined) {
            this.audioManager.src = src;
        }
        if (this.first) {
            this.first = false;
            Statistics(this.state.Data.bookID , 1, () => {
                this.state.Data.lookCount += 1;
            });
        }
        this.audioManager.play();
        this.setState({ playClass: 'jp-audio jp-state-playing' }, () => {
            this.SaveReadHistory();
        });
    }
    public onPre = () => {
        const preIndex = this.state.playIndex - 1;
        if (preIndex < 0) return;
        this.play(this.state.Data.sectionList[preIndex].fileUrl);
        this.setState({ playIndex: preIndex });
    }
    public onNext = () => {
        const nextIndex = this.state.playIndex + 1;
        if (nextIndex > this.state.Data.sectionList.length - 1) return;
        this.play(this.state.Data.sectionList[nextIndex].fileUrl);
        this.setState({ playIndex: nextIndex });
    }
    /**
     * 保存阅读记录
     */
    public SaveReadHistory = () => {
        const history = {
            playIndex: this.state.playIndex
        }
        localStorage.setItem(this.bookId.toString(), JSON.stringify(history));
    }
    public InitReadHistory = () => {
        const historyItem = localStorage.getItem(this.bookId.toString());
        if (historyItem !== null) {
            const history = JSON.parse(historyItem) as {playIndex: number};
            // console.log(history);
            if (history.playIndex !== 0) {
                this.ShowToast('是否跳转到上次播放记录?', 2, 0, () => {
                    this.RemoveToast();
                }, () => {
                    this.setState({playIndex: history.playIndex}, ()=>{
                        this.RemoveToast();
                        // console.log(this.audioManager.src)
                        this.audioManager.src = this.state.Data.sectionList[this.state.playIndex].fileUrl;
                        const dom = document.querySelector('dl > dd.on');
                        dom!.scrollIntoView({behavior: "smooth", block: "center", inline: "start"});
                        // console.log(this.audioManager.src, dom)
                    });
                });
                // this.setState({playIndex: history.playIndex}, func);
            }
        }
    }
    public render() {
        const { playClass, CurrentTime, Duration, Progress, playIndex } = this.state;
        const { ClassifyTitle, collect, sectionList, bookID, imgUrl, name, writer, lookCount, downCount, intro } = this.state.Data;
        const sectionListLayout = sectionList.map((v, i)=>{
            return <dd className={i === playIndex ? 'on' : ''} key={v.id} onClick={this.onItemClick.bind(this, v.fileUrl, i)}>
                <a>
                    <div className="c-img"><AsyncImg src={imgUrl} /></div>
                    <div className="c-tit">
                        <h1>{v.name}</h1>
                        <h2>{'大小：' + v.size}</h2>
                    </div>
                </a>
            </dd>
        });
        return (
            <div className="c-box">
                <div className="c-tingshuxq">
                    <div className="mt">
                        <div className="c-img"><AsyncImg src={imgUrl} /></div>
                        <div className="c-tit">
                            <h1>{name}</h1>
                            <p>{'栏目：' + ClassifyTitle}</p>
                            <p>{'作者：' + writer}</p>
                            <p>{'收听量：' + lookCount}</p>
                        </div>
                    </div>
                    <div className="mc">
                        <ul>
                            <li>
                                <a onClick={this.onPlayClick}>
                                    <div className="c-img"><img src={require('../img/img35.jpg')} /></div>
                                    <div className="c-tit">收听</div>
                                </a>
                            </li>
                            {/* <li className="c-shoucang">
                                <a href="#">
                                    <div className="c-img"></div>
                                    <div className="c-tit">收藏</div>
                                </a>
                            </li> */}
                        </ul>
                    </div>
                    <div className="mb">
                        <div className="c-slide">
                            <div className="hd">
                                <ul>
                                    <li>简介</li>
                                    <li className="on">目录</li>
                                </ul>
                            </div>
                            <div className="bd">
                                <ul>
                                    <li>
                                        <div className="c-jianjie">
                                            {intro}
                                        </div>
                                    </li>
                                </ul>
                                <ul>
                                    <li>
                                        <div className="c-t">{'共' + (sectionList.length - 1) + '章'}</div>
                                        <dl style={{WebkitOverflowScrolling: 'touch'}}>
                                           {sectionListLayout}
                                        </dl>
                                        {/* <div className="c-h305"></div> */}
                                        <div className="c-fixed">
                                            <div id="jquery_jplayer_1" className="jp-jplayer"></div>
                                            <div id="jp_container_1" className={playClass} role="application" aria-label="media player">
                                                <div className="jp-type-playlist">
                                                    <div className="jp-gui jp-interface">
                                                        <div className="jp-progress">
                                                            <div className="jp-seek-bar">
                                                                <div className="jp-play-bar" style={{width: Progress + '%'}}>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="jp-time-holder">
                                                            <div className="jp-current-time" role="timer" aria-label="time">{CurrentTime}</div>
                                                            <div className="jp-duration" role="timer" aria-label="duration">{Duration}</div>
                                                        </div>
                                                        <div className="jp-controls">
                                                            <button className="jp-previous" role="button" onClick={this.onPre}>previous</button>
                                                            <button className="jp-play" role="button" onClick={this.onPlayClick}>play</button>
                                                            <button className="jp-next" role="button" onClick={this.onNext}>next</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listen;
